var onSale = false;
var soldOut = false;
var priceVaries = false;
var images = [];
var firstVariant = {};
// Override Settings
var bcSfFilterSettings = {
  general: {
    limit: bcSfFilterConfig.custom.products_per_page,
    /* Optional */
    loadProductFirst: true,
    // Placeholder
    showPlaceholderProductList: true,
    placeholderProductPerRow: 6
  }
};

/************************** CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
function prepareShopifyData(data) {
  // Displaying price base on the policy of Shopify, have to multiple by 100
  soldOut = !data.available; // Check a product is out of stock
  onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
  priceVaries = data.price_min != data.price_max; // Check a product has many prices
  // Convert images to array
  images = data.images_info;
  // Get First Variant (selected_or_first_available_variant)
  var firstVariant = data["variants"][0];
  if (getParam("variant") !== null && getParam("variant") != "") {
    var paramVariant = data.variants.filter(function(e) {
      return e.id == getParam("variant");
    });
    if (typeof paramVariant[0] !== "undefined") firstVariant = paramVariant[0];
  } else {
    for (var i = 0; i < data["variants"].length; i++) {
      if (data["variants"][i].available) {
        firstVariant = data["variants"][i];
        break;
      }
    }
  }
  return data;
}
/************************** END CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
/************************** BUILD PRODUCT LIST **************************/
// Build Product Grid Item
BCSfFilter.prototype.buildProductGridItem = function(data, index) {
  // Get Template
  var itemHtml = bcSfFilterTemplate.productGridItemHtml;
  // Customize API data to get the Shopify data
  data = prepareShopifyData(data);
  // Add Custom class
  var soldOutClass = soldOut ? bcSfFilterTemplate.soldOutClass : "";
  var saleClass = onSale ? bcSfFilterTemplate.saleClass : "";
  itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);
  itemHtml = itemHtml.replace(/{{saleClass}}/g, saleClass);
  // Add Grid Width class
  itemHtml = itemHtml.replace(/{{gridWidthClass}}/g, buildGridWidthClass(data));
  // Add Label
  itemHtml = itemHtml.replace(/{{itemLabels}}/g, buildLabels(data));
  // Add TAG Label
  itemHtml = itemHtml.replace(
    /{{itemTagLabels}}/g,
    buildTagLabels(data, false)
  );
  // Add TAG for color variants
  itemHtml = itemHtml.replace(/{{itemTagColor}}/g, buildTagColor(data, false));
  // Add Images
  itemHtml = itemHtml.replace(/{{itemImages}}/g, buildImages(data));
  // Add Price
  itemHtml = itemHtml.replace(/{{itemPrice}}/g, buildPrice(data));
  // Add Variants
  itemHtml = itemHtml.replace(/{{itemVariants}}/g, buildVariants(data));
  // Add VariantsSelect
  itemHtml = itemHtml.replace(
    /{{itemVariantsSelect}}/g,
    buildVariantsSelect(data)
  );
  // Add VariantsSelect
  itemHtml = itemHtml.replace(/{{itemColors}}/g, buildColors(data));
  // Add Vendor
  itemHtml = itemHtml.replace(/{{itemVendor}}/g, buildVendor(data));
  // Add Button
  itemHtml = itemHtml.replace(/{{itemButton}}/g, buildButton(data));
  // itemActiveSwapClass
  var itemActiveSwapClass = bcSfFilterConfig.custom.active_image_swap
    ? "has-bc-swap-image"
    : "";
  itemHtml = itemHtml.replace(/{{itemActiveSwapClass}}/g, itemActiveSwapClass);

  // Add data json
  itemHtml = itemHtml.replace(/{{itemJson}}/g, JSON.stringify(data.json));

  // Add main attribute (Always put at the end of this function)
  itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
  itemHtml = itemHtml.replace(/{{itemProducts}}/g, data);
  itemHtml = itemHtml.replace(
    /{{itemIdSelected}}/g,
    data.selected_or_first_available_variant.id
  );
  itemHtml = itemHtml.replace(/{{itemAvailable}}/g, data.available);
  itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
  itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
  itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
  itemHtml = itemHtml.replace(/{{itemUrl}}/g, this.buildProductItemUrl(data));

  return itemHtml;
};
// Build Product List Item
BCSfFilter.prototype.buildProductListItem = function(data) {
  // For List View
  /*** Prepare data ***/
  var images = data.images_info;
  // Displaying price base on the policy of Shopify, have to multiple by 100
  var soldOut = !data.available; // Check a product is out of stock
  var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
  var priceVaries = data.price_min != data.price_max; // Check a product has many prices
  // Get First Variant (selected_or_first_available_variant)
  var firstVariant = data["variants"][0];
  if (getParam("variant") !== null && getParam("variant") != "") {
    var paramVariant = data.variants.filter(function(e) {
      return e.id == getParam("variant");
    });
    if (typeof paramVariant[0] !== "undefined") firstVariant = paramVariant[0];
  } else {
    for (var i = 0; i < data["variants"].length; i++) {
      if (data["variants"][i].available) {
        firstVariant = data["variants"][i];
        break;
      }
    }
  }
  /*** End Prepare data ***/
  // Get Template
  var itemHtml = bcSfFilterTemplate.productListItemHtml;
  // Customize API data to get the Shopify data
  data = prepareShopifyData(data);
  // Add Custom class
  var soldOutClass = soldOut ? bcSfFilterTemplate.soldOutClass : "";
  var saleClass = onSale ? bcSfFilterTemplate.saleClass : "";
  itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);
  itemHtml = itemHtml.replace(/{{saleClass}}/g, saleClass);
  // Add Label
  itemHtml = itemHtml.replace(/{{itemLabels}}/g, buildLabels(data));
  // Add TAG Label
  itemHtml = itemHtml.replace(
    /{{itemTagLabels}}/g,
    buildTagLabels(data, false)
  );
  // Add TAG for color variants
  itemHtml = itemHtml.replace(/{{itemTagColor}}/g, buildTagColor(data, false));
  // Add Images
  itemHtml = itemHtml.replace(/{{itemImages}}/g, buildImages(data));
  // Add Variants
  itemHtml = itemHtml.replace(/{{itemVariants}}/g, buildVariants(data));
  // Add VariantsSelect
  itemHtml = itemHtml.replace(
    /{{itemVariantsSelect}}/g,
    buildVariantsSelect(data)
  );
  // Add Vendor
  itemHtml = itemHtml.replace(/{{itemVendor}}/g, buildVendor(data));
  // Add Button
  itemHtml = itemHtml.replace(/{{itemButton}}/g, buildButton(data));
  // Add Price
  var itemPriceHtml = buildPrice(data, onSale, priceVaries);
  itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);
  // Description
  var itemDescription = jQ("<p>" + data.body_html + "</p>").text();
  itemDescription =
    itemDescription.split(" ").length > 40
      ? itemDescription
          .split(" ")
          .splice(0, 40)
          .join(" ") + "..."
      : itemDescription
          .split(" ")
          .splice(0, 40)
          .join(" ");
  itemHtml = itemHtml.replace(/{{itemDescription}}/g, itemDescription);
  // itemActiveSwapClass
  var itemActiveSwapClass = bcSfFilterConfig.custom.active_image_swap
    ? "has-bc-swap-image"
    : "";
  itemHtml = itemHtml.replace(/{{itemActiveSwapClass}}/g, itemActiveSwapClass);
  // Add main attribute
  itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
  itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
  itemHtml = itemHtml.replace(/{{itemUrl}}/g, this.buildProductItemUrl(data));
  return itemHtml;
  // End For List View
};
/************************** END BUILD PRODUCT LIST **************************/
/************************** BUILD PRODUCT ITEM ELEMENTS **************************/
function buildGridWidthClass() {
  var gridWidthClass = "";
  // On PC
  switch (bcSfFilterConfig.custom.products_per_row) {
    case 2:
      gridWidthClass = "bc-sf-filter-grid-width-2 col--1of2";
      break;
    case 3:
      gridWidthClass = "bc-sf-filter-grid-width-3 col--1of3";
      break;
    case 5:
      gridWidthClass = "bc-sf-filter-grid-width-5 col--1of5";
      break;
    default:
      gridWidthClass = "bc-sf-filter-grid-width-4 col--1of4";
      break;
  }
  // On Mobile
  switch (bcSfFilterConfig.custom.products_per_row_mobile) {
    case 1:
      gridWidthClass += " bc-sf-filter-grid-width-mb-1";
      break;
    case 3:
      gridWidthClass += " bc-sf-filter-grid-width-mb-3 col--1of3";
      break;
    default:
      gridWidthClass += " bc-sf-filter-grid-width-mb-2 col--1of2";
      break;
  }
  return gridWidthClass;
}

function buildImages(data) {
  var html = "";
  // Build Main Image
  var thumbUrl =
    images.length > 0
      ? bcsffilter.optimizeImage(images[0]["src"])
      : bcSfFilterConfig.general.no_image_url;
  html +=
    '<img src="' +
    thumbUrl +
    '" class="bc-sf-filter-product-item-main-image" />';
  // Build Image Swap
  if (bcSfFilterConfig.custom.active_image_swap) {
    var flipImageUrl =
      images.length > 1 ? bcsffilter.optimizeImage(images[1]["src"]) : thumbUrl;
    html +=
      '<img src="' +
      flipImageUrl +
      '" class="bc-sf-filter-product-item-flip-image" />';
  }
  return html;
}

function buildVariantsSelect(data) {
  var html = "";

  html +=
    '<select name="id" id="product-select-' +
    data.id +
    '" class="select hidden product-single__variants">';
  if (data.variants.length > 0) {
    for (var i = 0; i < data.variants.length; i++) {
      var output = "";
      var variant = data.variants[i];

      if (bcSfFilterConfig.custom.show_price) {
        if (variant.compare_at_price > 0) {
          output +=
            "<del>" +
            bcsffilter.formatMoney(variant.compare_at_price) +
            "</del> ";
          output +=
            "<ins class='bc-sf-filter-product-item-sale-price'>" +
            bcsffilter.formatMoney(variant.price) +
            "</ins>";
        } else {
          output +=
            "<span class='bc-sf-filter-product-item-regular-price'>" +
            bcsffilter.formatMoney(variant.price) +
            "</span>";
        }
      }
      html += '<option value="' + variant.id + '" data-price="' + output + '"';
      if (data.selected_or_first_available_variant.id == variant.id) {
        html += " selected";
      }
      if (variant.available == false) {
        html += " disabled";
      }
      html += ">" + variant.title + "</option>";
    }
  }
  html += "</select>";

  return html;
}

function buildVariants(data) {
  var html = "";
  if (data.variants.length > 1) {
    for (var i = 0; i < data.variants.length; i++) {
      var variant = data.variants[i];

      html += '<li><div class="radio';
      if (!variant.available) {
        html += " radio--disabled";
      }
      html += '">';
      html +=
        '<input type="radio" name="field-' +
        data.handle +
        "-" +
        data.id +
        '" id="field-' +
        data.handle +
        "-" +
        data.id +
        "-" +
        i +
        "-" +
        variant.id +
        '" value="' +
        variant.id +
        '" data-variant-index="' +
        i +
        '"';
      for (var j = 0; j < variant.options.length; j++) {
        var _option = data.options[j];

        for (var k = 0; k < variant.options.length; k++) {
          if (_option == variant.options[k]) {
            html += ' data-option="' + k + '" data-index="' + k + '"';
          }
        }
      }

      html += "/>";
      html +=
        '<label for="field-' +
        data.handle +
        "-" +
        data.id +
        "-" +
        i +
        "-" +
        variant.id +
        '" data-handle-name="' +
        variant.id +
        '">';
      if (data.variants[i].options.length == 1) {
        html += variant.title;
      } else {
        html += variant.option_size;
      }
      html += "</label>";
      html += "</div></li>";
    }
  }

  return html;
}

function buildVendor(data) {
  var html = "";
  if (bcSfFilterConfig.custom.show_vendor) {
    html = bcSfFilterTemplate.vendorHtml;
  }
  return html;
}

function buildButton(data) {
  var html = "";
  if (!data.available) {
    html = "false";
  } else {
    html = "true";
  }
  return html;
}

function buildPrice(data) {
  var html = "";
  if (data.selected_or_first_available_variant.option_color != undefined) {
    html += '<div class="product__color">';
    html += data.selected_or_first_available_variant.option_color;
    html += "</div>";
  }

  if (bcSfFilterConfig.custom.show_price) {
    html += '<div class="product__price">';
    if (onSale) {
      html +=
        "<del>" + bcsffilter.formatMoney(data.compare_at_price_min) + "</del> ";
      html +=
        '<ins class="bc-sf-filter-product-item-sale-price">' +
        bcsffilter.formatMoney(data.price_min) +
        "</ins>";
    } else {
      if (priceVaries) {
        html += bcSfFilterConfig.label_basic.from + " ";
      }
      html +=
        '<span class="bc-sf-filter-product-item-regular-price">' +
        bcsffilter.formatMoney(data.price_min) +
        "</span>";
    }
    html += "</div>";
  }
  return html;
}

function buildLabels(data) {
  // Build Sold out label
  var soldOutLabel = "";
  if (bcSfFilterConfig.custom.show_sold_out_label && soldOut) {
    soldOutLabel = bcSfFilterTemplate.soldOutLabelHtml.replace(
      /{{style}}/g,
      ""
    );
  }
  // Build Sale label
  var saleLabel = "";
  if (bcSfFilterConfig.custom.show_sale_label && onSale && !soldOut) {
    saleLabel = bcSfFilterTemplate.saleLabelHtml.replace(/{{style}}/g, "");
  }
  // Build Labels
  return soldOutLabel + saleLabel;
}
// BUILD LABEL PRODUCT WITH TAGS
function buildTagLabels(data, showall) {
  if (showall) {
    var tagLabel = "";
    if (data.tags) {
      for (var i = 0; i < data.tags.length; i++) {
        var tag = data.tags[i];
        if (tag.indexOf("pfs:label") !== -1) {
          var preTagLabel = bcSfFilterTemplate.tagLabelHtml.replace(
            /{{labelTag}}/g,
            tag.split("pfs:label-")[1]
          );
          tagLabel += preTagLabel;
        }
      }
    }
  } else {
    var tagLabel = "";
    if (data.tags) {
      for (var i = data.tags.length - 1; i >= 0; i--) {
        tag = data.tags[i];
        if (tag.indexOf("pfs:label") !== -1) {
          var preTagLabel = bcSfFilterTemplate.tagLabelHtml.replace(
            /{{labelTag}}/g,
            tag.split("pfs:label-")[1]
          );
          tagLabel += preTagLabel;
          break;
        }
      }
    }
  }
  return tagLabel;
}

var productTag;
function buildTagColor(data, showall) {
  if (data.tags) {
    var tagLabel = "";
    for (var i = 0; i < data.tags.length; i++) {
      var tag = data.tags[i];
      if (tag.indexOf("Style:") !== -1) {
        tagLabel = tag.split("Style:")[1];
      }
      if (tag.indexOf("style:") !== -1) {
        tagLabel = tag.split("style:")[1];
      }
    }
  }

  productTag = tagLabel;
  return tagLabel;
}

function buildColors(data) {
  var hasMoreColors = "";

  if (window.availableColors.hasOwnProperty(productTag)) {
    var hasMoreColors = "product--more-colors";
  }

  return hasMoreColors;
}

// Build Default Pagination event
BCSfFilter.prototype.buildDefaultPaginationEvent = function(data) {
  var self = this;
  var paginationSelector = this.getSelector("pagination");
  
  jQ(paginationSelector)
    .find("a")
    .unbind("click");
  jQ(paginationSelector)
    .find("a")
    .on("click", function(e) {
      e.preventDefault();
      self.internalClick = true;
      var newUrl = jQ(this).attr("href");
      self.onChangeData(newUrl, "page");
      jQ("body,html").animate(
        {
          scrollTop: jQ("#bc-sf-filter-wrapper").offset().top - 84
        },
        600
      );
    });
};


/************************** END BUILD PRODUCT ITEM ELEMENTS **************************/
/************************** BUILD TOOLBAR **************************/
// Build Pagination
BCSfFilter.prototype.buildPagination = function(totalProduct) {
  Shopify.colorLabels();

  // Get page info
  var currentPage = parseInt(this.queryParams.page);
  var totalPage = Math.ceil(totalProduct / this.queryParams.limit);
  // If it has only one page, clear Pagination
  if (totalPage == 1) {
    jQ(this.selector.pagination).html("");
    return false;
  }
  if (this.getSettingValue("general.paginationType") == "default") {
    var paginationHtml = bcSfFilterTemplate.paginateHtml;
    // Build Previous
    var previousHtml =
      currentPage > 1
        ? bcSfFilterTemplate.previousActiveHtml
        : bcSfFilterTemplate.previousDisabledHtml;
    previousHtml = previousHtml.replace(
      /{{itemUrl}}/g,
      this.buildToolbarLink("page", currentPage, currentPage - 1)
    );
    paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);
    // Build Next
    var nextHtml =
      currentPage < totalPage
        ? bcSfFilterTemplate.nextActiveHtml
        : bcSfFilterTemplate.nextDisabledHtml;
    nextHtml = nextHtml.replace(
      /{{itemUrl}}/g,
      this.buildToolbarLink("page", currentPage, currentPage + 1)
    );
    paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);
    // Create page items array
    var beforeCurrentPageArr = [];
    for (
      var iBefore = currentPage - 1;
      iBefore > currentPage - 3 && iBefore > 0;
      iBefore--
    ) {
      beforeCurrentPageArr.unshift(iBefore);
    }
    if (currentPage - 4 > 0) {
      beforeCurrentPageArr.unshift("...");
    }
    if (currentPage - 4 >= 0) {
      beforeCurrentPageArr.unshift(1);
    }
    beforeCurrentPageArr.push(currentPage);
    var afterCurrentPageArr = [];
    for (
      var iAfter = currentPage + 1;
      iAfter < currentPage + 3 && iAfter <= totalPage;
      iAfter++
    ) {
      afterCurrentPageArr.push(iAfter);
    }
    if (currentPage + 3 < totalPage) {
      afterCurrentPageArr.push("...");
    }
    if (currentPage + 3 <= totalPage) {
      afterCurrentPageArr.push(totalPage);
    }
    // Build page items
    var pageItemsHtml = "";
    var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
    for (var iPage = 0; iPage < pageArr.length; iPage++) {
      if (pageArr[iPage] == "...") {
        pageItemsHtml += bcSfFilterTemplate.pageItemRemainHtml;
      } else {
        pageItemsHtml +=
          pageArr[iPage] == currentPage
            ? bcSfFilterTemplate.pageItemSelectedHtml
            : bcSfFilterTemplate.pageItemHtml;
      }
      pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
      pageItemsHtml = pageItemsHtml.replace(
        /{{itemUrl}}/g,
        this.buildToolbarLink("page", currentPage, pageArr[iPage])
      );
    }
    paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
    jQ(this.selector.pagination).html(paginationHtml);
  }
};
// Build Sorting
BCSfFilter.prototype.buildFilterSorting = function() {
  if (
    bcSfFilterConfig.custom.show_sorting &&
    bcSfFilterTemplate.hasOwnProperty("sortingHtml")
  ) {
    jQ(this.selector.topSorting).html("");
    var sortingArr = this.getSortingList();
    if (sortingArr) {
      var paramSort = this.queryParams.sort || "";
      // Build content
      var sortingItemsHtml = "";
      for (var k in sortingArr) {
        activeClass = "";
        if (paramSort == k) {
          activeClass = "active";
        }
        sortingItemsHtml +=
          '<li><a href="#" data-sort="' +
          k +
          '" class="' +
          activeClass +
          '">' +
          sortingArr[k] +
          "</a></li>";
      }
      var html = bcSfFilterTemplate.sortingHtml.replace(
        /{{sortingItems}}/g,
        sortingItemsHtml
      );
      jQ(".bc-sf-filter-custom-sorting").html(html);
      if (
        jQ(".bc-sf-filter-custom-sorting").hasClass("bc-sf-filter-sort-active")
      ) {
        jQ(".bc-sf-filter-custom-sorting").toggleClass(
          "bc-sf-filter-sort-active"
        );
      }

      var labelSort = "";
      if (paramSort.length > 0) {
        var labelHandle = "sorting_" + paramSort.replace(/\-/g, "_");
        labelSort = bcSfFilterConfig.label[labelHandle];
      } else {
        labelSort = bcSfFilterConfig.label.sorting;
      }

      jQ(".bc-sf-filter-custom-sorting label span span").text(labelSort);
    }
  }
};

// Build Sorting event
BCSfFilter.prototype.buildSortingEvent = function() {
  var _this = this;
  jQ(".bc-sf-filter-filter-dropdown a").click(function(e) {
    e.preventDefault();
    onInteractWithToolbar(
      e,
      "sort",
      _this.queryParams.sort,
      jQ(this).data("sort")
    );
  });

  jQ(".bc-sf-filter-custom-sorting > label").click(function() {
    if (!jQ(".bc-sf-filter-filter-dropdown").is(":animated")) {
      jQ(".bc-sf-filter-filter-dropdown")
        .toggle()
        .parent()
        .toggleClass("bc-sf-filter-sort-active");
      jQ("#bc-sf-filter-tree").hide();
    }
  });

  jQ(this.getSelector("filterTreeMobileButton")).click(function() {
    jQ("#bc-sf-filter-top-sorting-mobile .bc-sf-filter-filter-dropdown").hide();
  });
};
// For Toolbar - Build Display type
BCSfFilter.prototype.buildFilterDisplayType = function() {
  var itemHtml = "<span>" + bcSfFilterConfig.label.toolbar_viewas + "</span>";
  itemHtml +=
    '<a href="' +
    this.buildToolbarLink("display", "list", "grid") +
    '" title="Grid view" class="bc-sf-filter-display-item bc-sf-filter-display-grid" data-view="grid"><span class="icon-fallback-text"><i class="fa fa-th" aria-hidden="true"></i><span class="fallback-text">Grid view</span></span></a>';
  itemHtml +=
    '<a href="' +
    this.buildToolbarLink("display", "grid", "list") +
    '" title="List view" class="bc-sf-filter-display-item bc-sf-filter-display-list" data-view="list"><span class="icon-fallback-text"><i class="fa fa-list" aria-hidden="true"></i><span class="fallback-text">List view</span></span></a>';
  var topDisplayTypeSelector = jQ(this.getSelector("topDisplayType"));
  var listProductSelector = jQ(this.getSelector("products"));
  topDisplayTypeSelector.html(itemHtml);
  // Active current display type
  topDisplayTypeSelector
    .find(".bc-sf-filter-display-item")
    .removeClass("active");
  if (this.queryParams.display == "list") {
    topDisplayTypeSelector
      .find(".bc-sf-filter-display-list")
      .addClass("active");
    listProductSelector
      .removeClass("bc-sf-filter-grid-view-items")
      .addClass("bc-sf-filter-list-view-items");
  } else if (this.queryParams.display == "grid") {
    topDisplayTypeSelector
      .find(".bc-sf-filter-display-grid")
      .addClass("active");
    listProductSelector
      .removeClass("bc-sf-filter-list-view-items")
      .addClass("bc-sf-filter-grid-view-items");
  }
};
// Build Display type event
BCSfFilter.prototype.buildDisplayTypeEvent = function() {
  var _this = this;
  var topDisplayTypeSelector = jQ(this.getSelector("topDisplayType"));
  var listProductSelector = jQ(this.getSelector("products"));
  jQ(this.getSelector("topDisplayType") + " a").click(function(e) {
    e.preventDefault();
    _this.internalClick = true;
    jQ(this)
      .parent()
      .children()
      .removeClass("active");
    jQ(this).addClass("active");
    if (_this.queryParams.display == "list") {
      topDisplayTypeSelector
        .find(".bc-sf-filter-display-list")
        .addClass("active");
      listProductSelector
        .removeClass("bc-sf-filter-grid-view-items")
        .addClass("bc-sf-filter-list-view-items");
    } else if (_this.queryParams.display == "grid") {
      topDisplayTypeSelector
        .find(".bc-sf-filter-display-grid")
        .addClass("active");
      listProductSelector
        .removeClass("bc-sf-filter-list-view-items")
        .addClass("bc-sf-filter-grid-view-items");
    }
    var newUrl = jQ(this).attr("href");
    _this.onChangeData(newUrl, "display");
  });
};
// Build Show Limit
BCSfFilter.prototype.buildFilterShowLimit = function() {
  if (
    bcSfFilterConfig.custom.show_limit &&
    bcSfFilterTemplate.hasOwnProperty("showLimitHtml")
  ) {
    jQ(this.selector.topShowLimit).html("");
    var numberList = this.getSettingValue("general.showLimitList");
    if (numberList != "") {
      // Build content
      var showLimitItemsHtml = "";
      var arr = numberList.split(",");
      for (var k = 0; k < arr.length; k++) {
        showLimitItemsHtml +=
          '<option value="' +
          arr[k].trim() +
          '">' +
          arr[k].trim() +
          "</option>";
      }
      var html = bcSfFilterTemplate.showLimitHtml.replace(
        /{{showLimitItems}}/g,
        showLimitItemsHtml
      );
      jQ(this.selector.topShowLimit).html(html);
      // Set value
      jQ(this.selector.topShowLimit + " select").val(this.queryParams.limit);
    }
  }
};
// Build Breadcrumb
BCSfFilter.prototype.buildBreadcrumb = function(colData, apiData) {
  if (bcSfFilterTemplate.hasOwnProperty("breadcrumbHtml")) {
    var breadcrumbItemsHtml = "";
    if (
      typeof colData !== "undefined" &&
      colData.hasOwnProperty("collection")
    ) {
      var colInfo = colData.collection;
      if (
        typeof this.collectionTags !== "undefined" &&
        this.collectionTags !== null
      ) {
        breadcrumbItemsHtml += bcSfFilterTemplate.breadcrumbItemLink
          .replace(/{{itemLink}}/g, "/collections/" + colInfo.handle)
          .replace(/{{itemTitle}}/g, colInfo.title);
        breadcrumbItemsHtml += " {{breadcrumbDivider}} ";
        breadcrumbItemsHtml += bcSfFilterTemplate.breadcrumbItemSelected.replace(
          /{{itemTitle}}/g,
          this.collectionTags[0]
        );
      } else {
        breadcrumbItemsHtml += bcSfFilterTemplate.breadcrumbItemSelected.replace(
          /{{itemTitle}}/g,
          colInfo.title
        );
      }
    } else {
      breadcrumbItemsHtml += bcSfFilterTemplate.breadcrumbItemSelected.replace(
        /{{itemTitle}}/g,
        this.getSettingValue("label.defaultCollectionHeader")
      );
    }
    var html = bcSfFilterTemplate.breadcrumbHtml.replace(
      /{{breadcrumbItems}}/g,
      breadcrumbItemsHtml
    );
    html = html.replace(
      /{{breadcrumbDivider}}/g,
      bcSfFilterTemplate.breadcrumbDivider
    );
    jQ(this.selector.breadcrumb).html(html);
  }
};
/************************** END BUILD TOOLBAR **************************/
function matchHeightImage() {
  jQ(".bc-sf-filter-product-item-main-image")
    .load(function() {
      var imageContainer = jQ(this).parent();
      imageContainer.css("width", "100%").css("height", jQ(this).height());
    })
    .each(function() {
      if (this.complete) jQ(this).load();
    });
}
// Add additional feature for product list, used commonly in customizing product list
BCSfFilter.prototype.buildExtrasProductList = function(data, eventType) {
  /* start-initialize-bc-al */
  var self = this;
  var alEnable = true;
  if (
    self.getSettingValue("actionlist.qvEnable") != "" ||
    self.getSettingValue("actionlist.atcEnable") != ""
  ) {
    alEnable =
      self.getSettingValue("actionlist.qvEnable") ||
      self.getSettingValue("actionlist.atcEnable");
  }
  if (alEnable === true && typeof BCActionList !== "undefined") {
    if (typeof bcActionList === "undefined") {
      bcActionList = new BCActionList();
    } else {
      if (
        typeof bcAlParams !== "undefined" &&
        typeof bcSfFilterParams !== "undefined"
      ) {
        bcActionList.initFlag = false;
        bcActionList.alInit(bcSfFilterParams, bcAlParams);
      } else {
        bcActionList.alInit();
      }
    }
  }
  /* end-initialize-bc-al */
  // Call theme init function
  if (typeof theme !== "undefined" && typeof theme.init === "function") {
    jQ(theme.init);
  }
  // End For List View
};
// Build additional elements
BCSfFilter.prototype.buildAdditionalElements = function(data, eventType) {
  var _this = this;
  var totalProduct =
    data.total_product +
    "<span> " +
    bcSfFilterConfig.label.items_with_count_other +
    "</span>";
  if (data.total_product == 1) {
    totalProduct =
      data.total_product +
      "<span> " +
      bcSfFilterConfig.label.items_with_count_one +
      "</span>";
  }
  jQ("#bc-sf-filter-total-product").html(totalProduct);
  matchHeightImage();
  jQ(window).resize(function() {
    matchHeightImage();
  });

  jQ("body")
    .find(".bc-sf-filter-skeleton-button")
    .remove();

  // Prevent double tap on iOS
  var isiOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  if (isiOS) {
    this.isMobile() &&
      jQ(".bc-sf-filter-product-item")
        .find("a")
        .on("touchstart", function() {
          isScrolling = !1;
        })
        .on("touchmove", function() {
          isScrolling = !0;
        })
        .on("touchend", function() {
          isScrolling || (window.location = jQ(this).attr("href"));
        });
  }

  // Fix image not loaded on mobile
  (this.isMobile() || null != navigator.userAgent.match(/iPad/i)) &&
    (setTimeout(function() {
      jQ(".bc-sf-filter-product-item-image img").each(function() {
        var a = jQ(this).attr("src") + "3";
        jQ(this).attr("src", a);
      });
    }, 200),
    setTimeout(function() {
      jQ(".bc-sf-filter-product-item-image img").each(function() {
        var a = jQ(this).attr("src") + "3";
        jQ(this).attr("src", a);
      });
    }, 2e3));
};

// Build Default layout
BCSfFilter.prototype.buildDefaultElements = function() {
  var isiOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream,
    isSafari = /Safari/.test(navigator.userAgent),
    isBackButton =
      window.performance &&
      window.performance.navigation &&
      2 == window.performance.navigation.type;
  if (!(isiOS && isSafari && isBackButton)) {
    var self = this,
      url = window.location.href.split("?")[0],
      searchQuery =
        self.isSearchPage() && self.queryParams.hasOwnProperty("q")
          ? "&q=" + self.queryParams.q
          : "";
    window.location.replace(url + "?view=bc-original" + searchQuery);
  }
};

function customizeJsonProductData(data) {
  for (var i = 0; i < data.variants.length; i++) {
    var variant = data.variants[i];
    var featureImage = data.images.filter(function(e) {
      return e.src == variant.image;
    });
    if (featureImage.length > 0) {
      variant.featured_image = {
        id: featureImage[0]["id"],
        product_id: data.id,
        position: featureImage[0]["position"],
        created_at: "",
        updated_at: "",
        alt: null,
        width: featureImage[0]["width"],
        height: featureImage[0]["height"],
        src: featureImage[0]["src"],
        variant_ids: [variant.id]
      };
    } else {
      variant.featured_image = "";
    }
  }
  var self = bcsffilter;
  var itemJson = {
    id: data.id,
    title: data.title,
    handle: data.handle,
    vendor: data.vendor,
    variants: data.variants,
    url: self.buildProductItemUrl(data),
    options_with_values: data.options_with_values,
    images: data.images,
    images_info: data.images_info,
    available: data.available,
    price_min: data.price_min,
    price_max: data.price_max,
    compare_at_price_min: data.compare_at_price_min,
    compare_at_price_max: data.compare_at_price_max
  };
  return itemJson;
}
BCSfFilter.prototype.prepareProductData = function(data) {
  var countData = data.length;
  for (var k = 0; k < countData; k++) {
    data[k]["images"] = data[k]["images_info"];
    if (data[k]["images"].length > 0) {
      data[k]["featured_image"] = data[k]["images"][0];
    } else {
      data[k]["featured_image"] = {
        src: bcSfFilterConfig.general.no_image_url,
        width: "",
        height: "",
        aspect_ratio: 0
      };
    }
    data[k]["url"] = "/products/" + data[k].handle;
    var optionsArr = [];
    var countOptionsWithValues = data[k]["options_with_values"].length;
    for (var i = 0; i < countOptionsWithValues; i++) {
      optionsArr.push(data[k]["options_with_values"][i]["name"]);
    }
    data[k]["options"] = optionsArr;
    if (
      typeof bcSfFilterConfig.general.currencies != "undefined" &&
      bcSfFilterConfig.general.currencies.length > 1
    ) {
      var currentCurrency = bcSfFilterConfig.general.current_currency
        .toLowerCase()
        .trim();
      function updateMultiCurrencyPrice(oldPrice, newPrice) {
        if (typeof newPrice != "undefined") {
          return newPrice;
        }
        return oldPrice;
      }
      data[k].price_min = updateMultiCurrencyPrice(
        data[k].price_min,
        data[k]["price_min_" + currentCurrency]
      );
      data[k].price_max = updateMultiCurrencyPrice(
        data[k].price_max,
        data[k]["price_max_" + currentCurrency]
      );
      data[k].compare_at_price_min = updateMultiCurrencyPrice(
        data[k].compare_at_price_min,
        data[k]["compare_at_price_min_" + currentCurrency]
      );
      data[k].compare_at_price_max = updateMultiCurrencyPrice(
        data[k].compare_at_price_max,
        data[k]["compare_at_price_max_" + currentCurrency]
      );
    }
    (data[k]["price_min"] *= 100),
      (data[k]["price_max"] *= 100),
      (data[k]["compare_at_price_min"] *= 100),
      (data[k]["compare_at_price_max"] *= 100);
    data[k]["price"] = data[k]["price_min"];
    data[k]["compare_at_price"] = data[k]["compare_at_price_min"];
    data[k]["price_varies"] = data[k]["price_min"] != data[k]["price_max"];
    var firstVariant = data[k]["variants"][0];
    if (getParam("variant") !== null && getParam("variant") != "") {
      var paramVariant = data[k]["variants"].filter(function(e) {
        return e.id == getParam("variant");
      });
      if (typeof paramVariant[0] !== "undefined")
        firstVariant = paramVariant[0];
    } else {
      var countVariants = data[k]["variants"].length;
      for (var i = 0; i < countVariants; i++) {
        if (data[k]["variants"][i].available) {
          firstVariant = data[k]["variants"][i];
          break;
        }
      }
    }
    data[k]["selected_or_first_available_variant"] = firstVariant;
    var countVariants = data[k]["variants"].length;
    for (var i = 0; i < countVariants; i++) {
      var variantOptionArr = [];
      var count = 1;
      var variant = data[k]["variants"][i];
      var variantOptions = variant["merged_options"];
      if (Array.isArray(variantOptions)) {
        var countVariantOptions = variantOptions.length;
        for (var j = 0; j < countVariantOptions; j++) {
          var temp = variantOptions[j].split(":");
          data[k]["variants"][i]["option" + (parseInt(j) + 1)] = temp[1];
          data[k]["variants"][i]["option_" + temp[0]] = temp[1];
          variantOptionArr.push(temp[1]);
        }
        data[k]["variants"][i]["options"] = variantOptionArr;
      }
      data[k]["variants"][i]["compare_at_price"] =
        parseFloat(data[k]["variants"][i]["compare_at_price"]) * 100;
      data[k]["variants"][i]["price"] =
        parseFloat(data[k]["variants"][i]["price"]) * 100;
    }
    data[k]["description"] = data[k]["content"] = data[k]["body_html"];
    if (
      data[k].hasOwnProperty("original_tags") &&
      data[k]["original_tags"].length > 0
    ) {
      data[k]["tags"] = data[k]["original_tags"].slice(0);
    }
    data[k]["json"] = customizeJsonProductData(data[k]);
  }
  return data;
};


// Fix image url issue of swatch option
function getFilePath(fileName, ext, version) {
    var self = bcsffilter;
    var ext = typeof ext !== 'undefined' ? ext : 'png';
    var version = typeof version !== 'undefined' ? version : '1';
    var prIndex = self.fileUrl.lastIndexOf('?');
    if (prIndex > 0) {
        var filePath = self.fileUrl.substring(0, prIndex);
    } else {
        var filePath = self.fileUrl;
    }
    filePath += fileName + '.' + ext + '?v=' + version;
    return filePath;
}

BCSfFilter.prototype.getFilterData=function(eventType,errorCount){function BCSend(eventType,errorCount){var self=bcsffilter;var errorCount=typeof errorCount!=="undefined"?errorCount:0;self.showLoading();if(typeof self.buildPlaceholderProductList=="function"){self.buildPlaceholderProductList(eventType)}self.beforeGetFilterData(eventType);self.prepareRequestParams(eventType);self.queryParams["callback"]="BCSfFilterCallback";self.queryParams["event_type"]=eventType;var url=self.isSearchPage()?self.getApiUrl("search"):self.getApiUrl("filter");var script=document.createElement("script");script.type="text/javascript";var timestamp=(new Date).getTime();script.src=url+"?t="+timestamp+"&"+jQ.param(self.queryParams);script.id="bc-sf-filter-script";script.async=true;var resendAPITimer,resendAPIDuration;resendAPIDuration=2e3;script.addEventListener("error",function(e){if(typeof document.getElementById(script.id).remove=="function"){document.getElementById(script.id).remove()}else{document.getElementById(script.id).outerHTML=""}if(errorCount<3){errorCount++;if(resendAPITimer){clearTimeout(resendAPITimer)}resendAPITimer=setTimeout(self.getFilterData("resend",errorCount),resendAPIDuration)}else{self.buildDefaultElements(eventType)}});document.getElementsByTagName("head")[0].appendChild(script);script.onload=function(){if(typeof document.getElementById(script.id).remove=="function"){document.getElementById(script.id).remove()}else{document.getElementById(script.id).outerHTML=""}}}this.requestFilter(BCSend,eventType,errorCount)};BCSfFilter.prototype.requestFilter=function(sendFunc,eventType,errorCount){sendFunc(eventType,errorCount)};


/* Begin patch boost-010 run 2 */
BCSfFilter.prototype.initFilter=function(){return this.isBadUrl()?void(window.location.href=window.location.pathname):(this.updateApiParams(!1),void this.getFilterData("init"))},BCSfFilter.prototype.isBadUrl=function(){try{var t=decodeURIComponent(window.location.search).split("&"),e=!1;if(t.length>0)for(var i=0;i<t.length;i++){var n=t[i],a=(n.match(/</g)||[]).length,r=(n.match(/>/g)||[]).length,o=(n.match(/alert\(/g)||[]).length,h=(n.match(/execCommand/g)||[]).length;if(a>0&&r>0||a>1||r>1||o||h){e=!0;break}}return e}catch(l){return!0}};
/* End patch boost-010 run 2 */
